import { Login } from 'components/Public'

function LoginPage  ()  {
  return <Login />
}

export default LoginPage

